import { render, staticRenderFns } from "./SegmentsManager.vue?vue&type=template&id=9b8bbd72&scoped=true&"
import script from "./SegmentsManager.vue?vue&type=script&lang=js&"
export * from "./SegmentsManager.vue?vue&type=script&lang=js&"
import style0 from "./SegmentsManager.vue?vue&type=style&index=0&id=9b8bbd72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8bbd72",
  null
  
)

export default component.exports